import { createEnv } from '@t3-oss/env-nextjs';
import { vercel } from '@t3-oss/env-nextjs/presets-zod';
import { z } from 'zod';

export const env = createEnv({
  server: {
    API_URL: z.url(),

    MAINTENANCE: z.string().optional().default(''),

    CLERK_PUBLISHABLE_KEY: z.string(),
    CLERK_SECRET_KEY: z.string(),

    LOGROCKET_KEY: z.string().optional(),

    SENTRY_AUTH_TOKEN: z.string().optional(),

    S3_BUCKET: z.string(),
    S3_REGION: z.string(),
    AWS_ACCESS_KEY_ID: z.string(),
    AWS_SECRET_ACCESS_KEY: z.string(),

    POSTHOG_KEY: z.string(),

    FREE_EXTERNSHIPS: z.string().optional().default(''),
    EXCLUDED_EXTERNSHIPS_FROM_CONTROL_GROUP: z.string().optional().default(''),
    EXCLUDED_EXTERNSHIPS_FROM_EXPERIMENT_GROUP: z.string().optional().default(''),
    AI_FEEDBACK_BLACKLISTED_EXTERNSHIP_IDS: z.string().optional().default(''),
  },
  client: {
    NEXT_PUBLIC_API_URL: z.url(),

    NEXT_PUBLIC_APPS_API_URL: z.url().optional(),

    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: z.string(),
    NEXT_PUBLIC_CLERK_SIGN_IN_URL: z.string(),
    NEXT_PUBLIC_CLERK_SIGN_UP_URL: z.string(),
    NEXT_PUBLIC_CLERK_SIGN_UP_FORCE_REDIRECT_URL: z.string().nullish(),
    NEXT_PUBLIC_CLERK_SIGN_UP_FALLBACK_REDIRECT_URL: z.string().nullish(),

    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: z.string(),

    NEXT_PUBLIC_LOGROCKET_KEY: z.string().optional(),

    NEXT_PUBLIC_SEGMENT_WRITE_KEY: z.string().optional(),

    NEXT_PUBLIC_POSTHOG_KEY: z.string(),

    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: z.string().optional(),

    NEXT_PUBLIC_DEFAULT_PAYMENT_PLAN_PRICE_ID: z.string().optional(),

    NEXT_PUBLIC_FREE_EXTERNSHIPS: z.string().optional().default(''),
    NEXT_PUBLIC_EXCLUDED_EXTERNSHIPS_FROM_CONTROL_GROUP: z.string().optional().default(''),
    NEXT_PUBLIC_EXCLUDED_EXTERNSHIPS_FROM_EXPERIMENT_GROUP: z.string().optional().default(''),

    NEXT_PUBLIC_PORTFOLIO_ASSETS_CDN_BASE_URL: z.url().optional().default('https://portfolio-dev.extern.com'),

    /** Origin for public portfolio links, e.g. https://www.extern.com — the /portfolios path is hardcoded in code. */
    NEXT_PUBLIC_PORTFOLIO_PUBLIC_BASE_URL: z.url().optional().default('https://www.extern.com'),
  },
  shared: {
    NODE_ENV: z.enum(['development', 'production', 'test']),
  },
  experimental__runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,

    NEXT_PUBLIC_APPS_API_URL: process.env.NEXT_PUBLIC_APPS_API_URL,

    NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,

    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
    NEXT_PUBLIC_CLERK_SIGN_IN_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_IN_URL,
    NEXT_PUBLIC_CLERK_SIGN_UP_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_UP_URL,
    NEXT_PUBLIC_CLERK_SIGN_UP_FORCE_REDIRECT_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_UP_FORCE_REDIRECT_URL,
    NEXT_PUBLIC_CLERK_SIGN_UP_FALLBACK_REDIRECT_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_UP_FALLBACK_REDIRECT_URL,

    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,

    NEXT_PUBLIC_LOGROCKET_KEY: process.env.NEXT_PUBLIC_LOGROCKET_KEY,

    NEXT_PUBLIC_SEGMENT_WRITE_KEY: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,

    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,

    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,

    NEXT_PUBLIC_DEFAULT_PAYMENT_PLAN_PRICE_ID: process.env.NEXT_PUBLIC_DEFAULT_PAYMENT_PLAN_PRICE_ID,

    NEXT_PUBLIC_FREE_EXTERNSHIPS: process.env.NEXT_PUBLIC_FREE_EXTERNSHIPS,
    NEXT_PUBLIC_EXCLUDED_EXTERNSHIPS_FROM_CONTROL_GROUP:
      process.env.NEXT_PUBLIC_EXCLUDED_EXTERNSHIPS_FROM_CONTROL_GROUP,
    NEXT_PUBLIC_EXCLUDED_EXTERNSHIPS_FROM_EXPERIMENT_GROUP:
      process.env.NEXT_PUBLIC_EXCLUDED_EXTERNSHIPS_FROM_EXPERIMENT_GROUP,

    NEXT_PUBLIC_PORTFOLIO_ASSETS_CDN_BASE_URL: process.env.NEXT_PUBLIC_PORTFOLIO_ASSETS_CDN_BASE_URL,

    NEXT_PUBLIC_PORTFOLIO_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_PORTFOLIO_PUBLIC_BASE_URL,
  },
  extends: [vercel()],
  skipValidation: !!process.env.CI || !!process.env.SKIP_ENV_VALIDATION || process.env.npm_lifecycle_event === 'lint',
});
